export const images=[
    {
        id:1,
        img:'./images/dice/dice_1.png'
    },
    {
        id:2,
        img:'./images/dice/dice_2.png'
    },
    {
        id:3,
        img:'./images/dice/dice_3.png'
    },
    {
        id:4,
        img:'./images/dice/dice_4.png'
    },
    {
        id:5,
        img:'./images/dice/dice_5.png'
    },
    {
        id:6,
        img:'./images/dice/dice_6.png'
    }


]